import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';

import css from './SubscriptionModal.module.css';

const SubscriptionModalComponent = props => {
    const {
        isOpen,
        onClose,
        onManageDisableScrolling,
        onSubmit,
        intl,
        className,
    } = props;

    const handleStripe = () => {
        onSubmit('stripe');
        onClose();
    };

    const handleInvoice = () => {
        onSubmit('invoice');
        onClose();
    };

    return (
        <Modal
            id="SubscriptionModal"
            isOpen={isOpen}
            onClose={onClose}
            onManageDisableScrolling={onManageDisableScrolling}
            usePortal
            className={classNames(css.root, className)}
        >
            <div className={css.content}>
                <h2 className={css.modalTitle}>
                    <FormattedMessage id="SubscriptionModal.title" />
                </h2>

                <p className={css.modalMessage}>
                    <FormattedMessage id="SubscriptionModal.message" />
                </p>

                <div className={css.actions}>
                    <PrimaryButton
                        className={css.paymentButton}
                        onClick={handleStripe}
                        type="button"
                    >
                        <FormattedMessage id="SubscriptionModal.payWithStripe" />
                    </PrimaryButton>

                    <SecondaryButton
                        className={css.paymentButton}
                        onClick={handleInvoice}
                        type="button"
                    >
                        <FormattedMessage id="SubscriptionModal.payWithInvoice" />
                    </SecondaryButton>
                </div>
            </div>
        </Modal>
    );
};

SubscriptionModalComponent.defaultProps = {
    className: null,
    isOpen: false,
    onClose: null,
    onSubmit: null,
};

SubscriptionModalComponent.propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onManageDisableScrolling: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
};

export default injectIntl(SubscriptionModalComponent);
